import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const manageProductsDeleteApi = createApi({
    reducerPath: "manageProductsDeleteApi",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: (headers) => {
    const token = localStorage.getItem("token");
    console.log("Token:", token);
    if (token) headers.set("authorization", `Bearer ${token}`);
    return headers;
}
    }),
    tagTypes: ["data"],  
    endpoints: (builder) => ({
        deleteProduct: builder.mutation({
            query: (id) => ({
                url: `/Product/delete/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["data"],
        }),
    }),
});

export const { useDeleteProductMutation } = manageProductsDeleteApi;
